import { Backdrop, Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { geoVisualAssets } from "@/theme/visualAssets";

type GlobalLoaderProps = {
  label?: string;
};

export function GlobalLoader({ label = "Carregando GeoAnalytics" }: GlobalLoaderProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const loaderLabel =
    label === "Carregando GeoAnalytics" ? t("common.loadingGeoAnalytics") : label;
  const loaderSrc = geoVisualAssets.loader[theme.palette.mode];

  return (
    <Backdrop
      open
      sx={{
        color: "text.primary",
        bgcolor: "background.default",
        zIndex: (theme) => theme.zIndex.modal + 1
      }}
    >
      <Stack spacing={2} sx={{ alignItems: "center", justifyContent: "center", px: 2 }}>
        <Box
          component="img"
          src={loaderSrc}
          alt=""
          aria-hidden
          sx={{
            width: { xs: 112, sm: 148 },
            height: "auto",
            display: "block",
            backgroundColor: "transparent",
            objectFit: "contain",
            mixBlendMode: "normal"
          }}
        />
        <Typography color="text.secondary" sx={{ fontWeight: 700, textAlign: "center" }}>
          {loaderLabel}
        </Typography>
      </Stack>
    </Backdrop>
  );
}
